import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { OptionTypeBase, ValueType } from 'react-select';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { generateNewKeys } from '../../../stores/servers/actionCreators';
import { getServerName } from '../../../stores/servers/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { workspaceOptions } from '../../../stores/workspaces/selectors';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    generateNewKeys: (serverHostNames: string[]) => void;
    getName: (hostname: string) => string;
}

interface State {
    showModal: boolean;
}

class GenerateNewKeysAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'key']} />
                        {t('servers.button.generateKey')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('servers.modal.generateKey.header') as string}
                        confirmText={t('modal.apply') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.generate();
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('servers.modal.generateKey.text') as string} <b>{this.getHandle()}</b>?

                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private generate = () => {
        this.props.generateNewKeys(this.props.selected);
    }

    private getHandle = () => {
        const t = this.props.translate;
        if (this.props.selected.length !== 1) {
            return t(
                'servers.modal.delete.servers',
                { number: this.props.selected.length }
            );
        } else {
            return this.props.getName(this.props.selected[0]);
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    getName: getServerName(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'servers'),
    
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    generateNewKeys: (serverHostNames: string[]) =>
        dispatch(generateNewKeys(serverHostNames)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(GenerateNewKeysAction));